module.exports = __webpack_public_path__ + "static/media/cases_logos_eventos_05.c39be7b9.jpg";